import React, { FC } from 'react'
import { ContentBlockContainer } from './styled'

interface ContentBlockProps {
	className?: string
	withoutHeader?: boolean
	withoutShadow?: boolean
	smallIndent?: boolean
	centered?: boolean
}

export const ContentBlockComponent: FC<ContentBlockProps> = ({
	className,
	withoutHeader,
	withoutShadow,
	smallIndent,
	centered,
	children,
}) => {
	return children ? (
		<ContentBlockContainer
			className={className}
			withoutHeader={withoutHeader}
			withoutShadow={withoutShadow}
			smallIndent={smallIndent}
			centered={centered}
		>
			{children}
		</ContentBlockContainer>
	) : null
}
